<mat-selection-list #matSelection role="list" class="list-jornadas" (selectionChange)="getSelected($event)"
   [formControl]="control">
  <mat-list-option #matOptions *ngFor="let item of dataSourceList" [value]="item">
    {{ item.IdLegajo + ' - ' + item.Apellido + ' ' + item.Nombre }}
  </mat-list-option>
</mat-selection-list>
